// Flash message handling
export function handleFlashMessages() {
  // Check if we have flash messages
  if (!window.flashMessages || !window.flashMessages.messages) return;

  console.log('Processing flash messages:', window.flashMessages.messages);

  // Process each message
  const messages = window.flashMessages.messages;
  Object.entries(messages).forEach(([type, message]) => {
    if (!message) return;

    console.log('Showing message:', type, message);
    switch(type) {
      case 'notice':
        toastr.info(message);
        break;
      case 'success':
        toastr.success(message);
        break;
      case 'error':
        toastr.error(message);
        break;
      case 'alert':
        toastr.warning(message);
        break;
    }
  });

  // Clear the messages
  window.flashMessages = { messages: {} };
}

export function showMessage(message, type) {
  if (!message) return;
  
  console.log('Showing message:', type, message);
  switch(type) {
    case 'notice':
      toastr.info(message);
      break;
    case 'success':
      toastr.success(message);
      break;
    case 'error':
      toastr.error(message);
      break;
    case 'alert':
      toastr.warning(message);
      break;
    default:
      toastr.info(message);
  }
}
